import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Section } from "@faire/retailer-visitor-shared/views/point-of-sale/landing-page/components/Section";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
export var HowItWorksSection = function() {
    var isMobile = useViewport().isMobile;
    if (isMobile) {
        return /*#__PURE__*/ _jsxs(Section, {
            color: Core.surface.subdued,
            children: [
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "7x"
                }),
                /*#__PURE__*/ _jsxs(Column, {
                    gap: "3x",
                    children: [
                        /*#__PURE__*/ _jsx(SectionHeading, {}),
                        STEPS.map(function(param, index) {
                            var heading = param.heading, body = param.body;
                            return /*#__PURE__*/ _jsxs(Column, {
                                gap: "1x",
                                children: [
                                    /*#__PURE__*/ _jsx(Typography, {
                                        variant: "paragraphSansMedium",
                                        children: heading
                                    }),
                                    /*#__PURE__*/ _jsx(Typography, {
                                        children: body
                                    })
                                ]
                            }, index);
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "7x"
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs(Section, {
        color: Core.surface.subdued,
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                height: "9x"
            }),
            /*#__PURE__*/ _jsx(SectionHeading, {}),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "6x"
            }),
            /*#__PURE__*/ _jsx(Row, {
                gap: {
                    mobileAndAbove: "5x",
                    desktopAndAbove: "9x"
                },
                children: STEPS.map(function(param, index) {
                    var heading = param.heading, body = param.body;
                    return /*#__PURE__*/ _jsxs(Column, {
                        gap: "1x",
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "subheadingSansMedium",
                                children: heading
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "subheadingSansRegular",
                                children: body
                            })
                        ]
                    }, index);
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: {
                    mobileAndAbove: "10x",
                    desktopAndAbove: 104
                }
            })
        ]
    });
};
var SectionHeading = function() {
    return /*#__PURE__*/ _jsx(Typography, {
        variant: "displaySSerifRegular",
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "mi1zVL",
            defaultMessage: [
                {
                    type: 0,
                    value: "How it works"
                }
            ]
        })
    });
};
var STEPS = [
    {
        heading: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "cX9TvM",
            defaultMessage: [
                {
                    type: 0,
                    value: "01 \u2014 Connect and configure"
                }
            ]
        }),
        body: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "mUjz80",
            defaultMessage: [
                {
                    type: 0,
                    value: "Connect your POS system to Faire. Adjust settings to control how information gets transferred to your POS."
                }
            ]
        })
    },
    {
        heading: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "Jlq4lc",
            defaultMessage: [
                {
                    type: 0,
                    value: "02 \u2014 Import your orders"
                }
            ]
        }),
        body: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "kXQVMM",
            defaultMessage: [
                {
                    type: 0,
                    value: "No more copy and paste. We'll automatically import product information to your POS, in the way you want it to appear."
                }
            ]
        })
    },
    {
        heading: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "tXPpxD",
            defaultMessage: [
                {
                    type: 0,
                    value: "03 \u2014 Track your inventory"
                }
            ]
        }),
        body: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "ak5eoQ",
            defaultMessage: [
                {
                    type: 0,
                    value: "Once products are linked, information such as inventory counts will stay synced between Faire and your POS system."
                }
            ]
        })
    }
];
